import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[56px] w-full rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-50)] bg-[var(--surface-panel-solid)] px-[var(--control-padding-x-tight)] py-1.5 text-sm leading-5 text-[var(--neutral-gray-120)] placeholder:text-[var(--neutral-gray-80)] focus-visible:outline-none focus-visible:border-[var(--azure-primary)] focus-visible:ring-2 focus-visible:ring-[var(--azure-focus-ring)] disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-[var(--neutral-gray-20)]",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
